<template>
  <div class="combobox-rental-intake-display">
    <ComboboxRentalMutationBaseDisplay
      :item="item"
      :instruction="instruction"
      :flow-direction="flowDirection"
      :is-list-item="isListItem"
      :is-being-updated="isBeingUpdated"
      :show-date="showDate"
      :show-project="showProject"
      :show-badge="showBadge"
      :show-counter-booking="showCounterBooking"
      :show-error="showError"
      :error="error"
      @clear-error="$emit('clearError')"
    >
      <ComboboxRentalIntakeItemInfo
        :rental-intake-item="rentalIntake.rentalIntakeItem"
        :instruction="instruction"
      />
      <div v-if="rentalIntake.counterMutation?.adminComment" class="italic">
        <FontAwesomeIcon :icon="['fas', 'comment']" class="mr-0.5" />
        <span v-if="rentalIntake.isReturn()" class="text-xs">(uitgifte)</span>
        {{ rentalIntake.counterMutation.adminComment }}
      </div>
      <div v-if="rentalIntake.adminComment" class="italic">
        <FontAwesomeIcon :icon="['fas', 'comment']" class="mr-0.5" />
        <span v-if="rentalIntake.isReturn()" class="text-xs">(retour)</span>
        {{ rentalIntake.adminComment }}
      </div>
    </ComboboxRentalMutationBaseDisplay>

    <!-- Linked incoming invoices -->
    <div v-if="rentalIntake.incomingInvoiceReferences.length > 0" class="italic">
      <FontAwesomeIcon :icon="['fas', 'link']" size="sm" />

      {{
        rentalIntake.incomingInvoiceReferences.length === 1 ? "Inkoopfactuur" : "Inkoopfacturen:"
      }}
      <span v-for="(reference, index) in rentalIntake.incomingInvoiceReferences" :key="index">
        {{ reference }}
        <span v-if="index < rentalIntake.incomingInvoiceReferences.length - 1">, </span>
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RentalIntake } from "@/models/rental-intake.model"
import { computed, inject } from "vue"
import { Instruction } from "@/models/instruction.model"
import ComboboxRentalMutationBaseDisplay from "@/components/administration/combobox-display-templates/nested/ComboboxRentalMutationBaseDisplay.vue"
import ComboboxRentalIntakeItemInfo from "@/components/administration/combobox-display-templates/basic/ComboboxRentalIntakeItemInfo.vue"
import { BaseException } from "@/exceptions/base-exception.exception"
import { RentalMutationFlowDirections } from "@/enums/rental-mutation-flow-directions"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

const props = defineProps<{
  item: RentalIntake | [RentalIntake]
  flowDirection: RentalMutationFlowDirections
  isListItem: boolean
  isBeingUpdated: boolean
  showDate?: boolean
  showProject?: boolean
  showBadge?: boolean
  showCounterBooking?: boolean
  showError?: boolean
  error?: BaseException
}>()

defineEmits(["clearError"])

const rentalIntake = computed(() => {
  if (props.item instanceof RentalIntake) {
    return props.item
  }
  return props.item[0]
})

const instruction = inject<Instruction>("instruction")!
</script>

<style scoped></style>
